/**
 * File: AccordionList.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.0
 * Created: 2025-08-17
 * Last Updated: 2025-11-06
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useState } from "react";

// Local project files
import Accordion from "../ui/Accordion";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function AccordionList({ panels }) {
    const [activePanel, setActivePanel] = useState(null);

    const handleToggle = (panelID) => {
        if (panelID === activePanel) {
            setActivePanel(null);
        } else {
            setActivePanel(panelID);
        }
    };

    return (
        <>
            <div className="accordion-list">
                {panels.map((panel) => (
                    <Accordion
                        key={panel.id}
                        panelID={panel.id}
                        header={panel.header}
                        content={panel.content}
                        isActive={panel.id === activePanel}
                        onToggle={handleToggle}
                    />
                ))}
            </div>
        </>
    );
}

export default AccordionList;
